export const isSessionExpired = (expiresIn: number): boolean => {
  return expiresIn <= Date.now();
};
